
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Title from '../Title/index.vue'

@Component({
  components: {
    Title
  }
})
export default class Book extends Vue {
  bookList: Array<{
    path: string
    imgUrl: string
    name: string
  }> = [
    {
      path: '/books?file=book-02',
      imgUrl: this.$images.my_classroom_book_02,
      name: '暄桐学生手册'
    },
    {
      path: '/books?file=book-01',
      imgUrl: this.$images.my_classroom_book_01,
      name: '暄桐的50个基本'
    },
    {
      path: '/books',
      imgUrl: this.$images.my_classroom_book_03,
      name: '暄桐60帖'
    }
  ]

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
